import { c as _c } from "react/compiler-runtime";
import { ContactSupportLocations } from "@custom-types/types";
import { Box } from "@mui-wrapper";
import { FontWeights, Link } from "@flat-ui";
import { contactSupport } from "@utils/email-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Defines the base page for an error, showing for example a
 * 404 page or an access denied page.
 */
export function ErrorPageBase(t0) {
  const $ = _c(19);
  const {
    title,
    children,
    iconImg,
    shouldShowSupportBtn: t1
  } = t0;
  const shouldShowSupportBtn = t1 === undefined ? false : t1;
  const {
    trackEvent
  } = useTrackEvent();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textAlign: "center",
      width: "100%"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      maxWidth: "565px"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== iconImg) {
    t4 = <Box component="div"><Box component="img" src={iconImg} sx={t3} /></Box>;
    $[2] = iconImg;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "text.secondary",
      fontSize: "38px",
      fontWeight: FontWeights.SemiBold,
      marginTop: "45px",
      marginBottom: "36px"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== title) {
    t6 = <Box component="div" sx={t5}>{title}</Box>;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      justifyContent: "center"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "text.secondary",
      fontSize: "20px",
      maxWidth: "880px"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== shouldShowSupportBtn || $[10] !== trackEvent) {
    t9 = shouldShowSupportBtn && <Link component="button" onClick={() => contactSupport({
      location: ContactSupportLocations.selectWorkspacePage,
      trackEvent
    })}>.</Link>;
    $[9] = shouldShowSupportBtn;
    $[10] = trackEvent;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== children || $[13] !== t9) {
    t10 = <Box component="div" sx={t7}><Box component="div" sx={t8}>{children}{t9}</Box></Box>;
    $[12] = children;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t4 || $[17] !== t6) {
    t11 = <Box component="div" sx={t2} data-testid="error-page">{t4}{t6}{t10}</Box>;
    $[15] = t10;
    $[16] = t4;
    $[17] = t6;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}